var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6332 13.8668L18.6875 11.9212V9.34375C18.6853 7.56257 18.0227 5.84548 16.8278 4.52452C15.633 3.20355 13.9908 2.37255 12.2188 2.19219V0.71875H10.7812V2.19219C9.00922 2.37255 7.36702 3.20355 6.17217 4.52452C4.97733 5.84548 4.31473 7.56257 4.3125 9.34375V11.9212L2.36684 13.8668C2.23204 14.0016 2.15629 14.1844 2.15625 14.375V16.5312C2.15625 16.7219 2.23198 16.9047 2.36677 17.0395C2.50156 17.1743 2.68438 17.25 2.875 17.25H7.90625V17.9688C7.90625 18.9219 8.28488 19.836 8.95884 20.5099C9.63279 21.1839 10.5469 21.5625 11.5 21.5625C12.4531 21.5625 13.3672 21.1839 14.0412 20.5099C14.7151 19.836 15.0938 18.9219 15.0938 17.9688V17.25H20.125C20.3156 17.25 20.4984 17.1743 20.6332 17.0395C20.768 16.9047 20.8438 16.7219 20.8438 16.5312V14.375C20.8437 14.1844 20.768 14.0016 20.6332 13.8668ZM13.6562 17.9688C13.6562 18.5406 13.4291 19.0891 13.0247 19.4935C12.6203 19.8978 12.0719 20.125 11.5 20.125C10.9281 20.125 10.3797 19.8978 9.9753 19.4935C9.57093 19.0891 9.34375 18.5406 9.34375 17.9688V17.25H13.6562V17.9688Z",
    fill: "#D4D4D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationLight);
export default __webpack_public_path__ + "static/media/notification-light.fb45cafa34e3951ce60790e6b983fd37.svg";
export { ForwardRef as ReactComponent };